module.exports = __webpack_public_path__ + "img/Wing.e8d5014b.png";